import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-variation',
  templateUrl: './variation.component.html',
  styleUrls: ['./variation.component.scss']
})
export class VariationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
